// @vendors
import React, { useMemo } from 'react'
import {
    Box,
    Card,
    Grid,
    Typography,
} from '@mui/material'
import { useSelector } from 'react-redux';

// @assets
import { DashboardStyles } from '../../../assets/css/dashboard-style';
import { theme } from '../../../assets/theme';
import { StatsStyles } from '../../../assets/css/statsBoxes-style';

// @context
import { useUI } from '../../../app/context/ui';

// @helpers
import { getTemplateForCertification } from '../../../helpers/FunctionsUtils';
import AppButton from '../../../components/forms/AppButton';

const BulkFiles = () => {
    const styles = useMemo(() => DashboardStyles(), []);
    const styleStats = useMemo(() => StatsStyles(), []);
    const globalState = useSelector((state) => state);
    const user = globalState.user;
    const { blockUI, snackbarUI } = useUI();

    const fetchTemplateArizona = async () => {
        const params ={
            pathUrl: '/api/internal/v1/submitter/arizona',
            token: user?.accessToken,
            fileName: 'bulk_template_for_Arizona.csv',
            blockUI,
            snackbarUI
        }
        //download .zip file
        getTemplateForCertification(params);
    }

  return (
    <Grid sx={{width: '100%'}}>
        <Card elevation={1} sx={styles.containerIsMonday}>
            <Typography sx={styleStats.statsTitle}>
                7 days prior bulk files:
            </Typography>

            <Box>
                <AppButton
                    onPress={fetchTemplateArizona}
                    label="Arizona"
                    color="primary"
                    bgColor={theme.palette.primary.black}
                    sx={styleStats.buttonSearch}
                    size="large"
                />
            </Box>
        </Card>
    </Grid>
  )
}

export default BulkFiles